<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Onay Türü</label>
            <v-select-list :options="requiredConfirmationTypes" label="name" v-model="requiredConfirmationType" placeholder="Onay Türü"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">SGK Şubesi</label>
            <v-select-list :disabled="value.BranchChangable == false" :options="branches" label="Name" v-model="sgkBranch" placeholder="SGK Şube"></v-select-list>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.SendSMS">SMS ile bildir</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object
    },
    data(){
        return {
            branches:[],
            requiredConfirmationTypes:[
                {name:'Tek kullanıcı onayı yeterli.',value:0},
                {name:'Tüm kullanıcıların onayı gerekli.',value:1}
            ]
        }
    },
    mounted(){
        this.getBranches()
    },
    methods:{
        getBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.branches = res.data.Data
            })
        },
    },
    computed:{
        sgkBranch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.value.SGKBranchId)
            },
            set:function(value){
                this.value.SGKBranchId = value?.Id || null
            }
        },
        requiredConfirmationType:{
            get:function(){
                return this.requiredConfirmationTypes.find(b=>b.value==this.value.RequiredConfirmationType)
            },
            set:function(value){
                this.value.RequiredConfirmationType = value?.value >= 0 ? value.value : null
            }
        },
    }
}
</script>